import * as React from "react";

function deActive(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19.48}
      height={10.198}
      {...props}
    >
      <path
        id="Path_26553"
        data-name="Path 26553"
        d="M268.328,330.043c-1.524,0-3.047.007-4.571,0a5.088,5.088,0,0,1-.457-10.161c.556-.04,1.115-.029,1.673-.03q3.949,0,7.9,0a5.087,5.087,0,0,1,.5,10.158c-.729.049-1.462.029-2.194.033-.95,0-1.9,0-2.851,0Zm-1.692-.934h.256c1.705,0,3.411,0,5.116,0a12.957,12.957,0,0,0,1.536-.045,4.156,4.156,0,0,0-.557-8.275H266.64A5.113,5.113,0,0,1,266.636,329.108Zm-7.114-4.161a4.173,4.173,0,1,0,4.2-4.162A4.18,4.18,0,0,0,259.522,324.948Z"
        transform="translate(-258.592 -319.848)"
        fill="#3f4255"
      />
    </svg>
  );
}

export default deActive;
